export default "__VITE_ASSET__G$uKp9az__"